module.exports = __webpack_public_path__ + "img/SOC2.797d9eb0.png";